// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"179":"components","223":"commons","435":"priority","501":"postload"}[chunkId] + ".chunk.B77CoriginmasterD20250813183550.js";
};